module.exports = __webpack_public_path__ + "static/media/Fairways-West-HOA-Covenants-Restrictions.e68ce03a.pdf";